import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col-lg-12 col-md-12 col-12" }
const _hoisted_2 = { class: "itemcard full" }
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "IP Address"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Anonymity"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Protocol")
  ])
], -1)
const _hoisted_5 = { id: "proxytable" }

import axios from 'axios';
import { reactive } from 'vue';

type State = {
  http: string[];
  socks4: string[];
  socks5: string[];
  data: any[];
  // eslint-disable-next-line semi
};

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state: State = reactive({
  http: [],
  socks4: [],
  socks5: [],
  data: [],
});

axios
  .get('https://api.proxyscrape.com/proxytable.php')
  .then(({ data }) => {
    const proxyStatus: any = {
      1: 'Transparent',
      2: 'Anonymous',
      3: 'Elite',
    };
    const rData: any[] = [];

    Object.keys(data).forEach((protocol) => {
      Object.keys(data[protocol]).forEach((ip) => {
        const status = proxyStatus[data[protocol][ip]];

        rData.push({ protocol, ip, status });
      });
    });
    state.data = rData;
  })
  .catch((e) => console.log(e));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).data, (ip) => {
            return (_openBlock(), _createElementBlock("tr", { key: ip }, [
              _createElementVNode("td", null, _toDisplayString(ip.ip), 1),
              _createElementVNode("td", null, _toDisplayString(ip.status), 1),
              _createElementVNode("td", null, _toDisplayString(ip.protocol), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})